export const transformTimeToDate = (timeString: string) => {
    const date = new Date();
    const time = timeString.split(":");
    date.setHours(parseInt(time[0]))
    date.setMinutes(parseInt(time[1]))
    return date;
  
  }